// src/pages/Whitelist/Whitelist.jsx
import React from 'react';
import WhitelistForm from '../../components/WhitelistForm/WhitelistForm';
import '../../components/WhitelistForm/WhitelistForm.css';
import './Whitelist.css'; // Si tienes estilos específicos para la página Whitelist en sí misma
import bgImg from '../../assets/night-city-lights-city-grand-theft-auto-v-gta5-hd-wallpaper-a8b66d38a030dc28101c81def822440a.jpg';

const Whitelist = () => {
  const pageStyle = {
    backgroundImage: `url(${bgImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
  };

  return (
    <div className="whitelist-page public-page-with-header" style={pageStyle}>
      {/* Puedes añadir una sección de bienvenida o información aquí */}
      <WhitelistForm />
    </div>
  );
};

export default Whitelist;